import { AppRoutes } from '../../shared/constants/enums'
import { NavigationLink } from '../../shared/models/interfaces'

export const PATH_ICON: string = './assets/icons/'

export const SITE_MENU: NavigationLink[] = [
    { link: AppRoutes.GUARANTEE_ORDERS, text: 'guaranteeOrders', icon: 'Order', exact: false }
]
